import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import Corbado from '@corbado/web-js';
import { UserService, UserState } from './services/user-service/user.service';
import { environment } from '../environments/environment';
import { ToastComponent } from "./commons/toast/toast.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit , OnDestroy {
  title = 'arthawell-web';
  reloadSession: any;

  constructor(private userService: UserService) { }
  
  async ngOnInit() {
    this.reloadSession = setInterval(async () => {
      await Corbado.load({
          projectId: environment.CORBADO_PROJECT_ID,
          darkMode: 'off',
          theme: "corbado-styles"
      });
      let state = Corbado.user;
      if (state) {
        let oldState = this.userService.getUserState();
        let userState: UserState = {
          isAuthenticated: true,
          userData: state,
          token: Corbado.sessionToken!,
          roles: oldState.roles,
          lastLogin: new Date(),
          preferences: undefined
        }
        this.userService.setUserState(userState);
      }
    }, 1000 * 60 * 10);
  }
  
  ngOnDestroy(): void {
    clearInterval(this.reloadSession);
  }


}
